import { ReactNode } from "react";
import { FormattedText } from "../../general/FormattedText";

type Props = {
  children: string | ReactNode[];
};

const LinkText = ({ children }: Props) => {
  if (!children) {
    return null;
  }

  return <FormattedText>{children}</FormattedText>;
};

export default LinkText;
